export default __webpack_public_path__ + "static/sentinel-6f6b9831db5715c0736fdf5880ee0ff8.png";